import { fmtCredit } from './deskFormat'
import { fmtInt } from './format'
import type { DeskGroup } from './deskPeriod'

/** The big number on a tile. Everyone stays an integer; a group's counts can be
 *  fractional (R14), so they print whole when whole, else one decimal. Rates are percentages. */
export function tileValueText(v: number | null, points: boolean, group: DeskGroup = 'all'): string {
  if (v === null) return '—'
  if (points) return `${Math.round(v * 100)}%`
  return group === 'all' ? fmtInt(Math.round(v)) : fmtCredit(v)
}
